import _ from 'lodash';

class UndoRedoHistory {
    store;
    history = [];
    currentIndex = 0;

    /**
     * Initialize the store
     *
     * @function   init
     */
    init(store) {
        this.store = store;
    }
    /**
     * Add state to the history
     *
     * @function   addState
     */
    addState(state) {
        // may be we have to remove redo steps
        if (this.currentIndex + 1 < this.history.length) {
            this.history.splice(this.currentIndex + 1);
        }
        this.history.push(_.cloneDeep(state));
        this.currentIndex++;
    }
    /**
     * Undo the last state
     *
     * @function   undo
     */
    undo() {
        const prevState = this.history[this.currentIndex - 1];
        // take a copy of the history state
        // because it would be changed during store mutations
        // what would corrupt the undo-redo-history
        // (same on redo)
        this.store.replaceState(_.cloneDeep(prevState));
        this.currentIndex--;
    }
    /**
     * Check if can undo the last state
     *
     * @function   canUndo
     */
    canUndo () {
        return this.history[this.currentIndex - 1] !== undefined || this.currentIndex > 0;
    }
    /**
     * Redo the last state
     *
     * @function   redo
     */
    redo() {
        const nextState = this.history[this.currentIndex + 1];
        this.store.replaceState(_.cloneDeep(nextState));
        this.currentIndex++;
    }
    /**
     * Check if can redo the last state
     *
     * @function   canRedo
     */
    canRedo () {
        return this.history[this.currentIndex + 1] !== undefined;
    }

}

export default new UndoRedoHistory();



// WEBPACK FOOTER //
// ./demo/store/plugins/undoRedoHistory.js